export const WeightInputUnit = {
  grams: 'grams',
  gram: 'gram',
  ounces: 'ounces',
  ounce: 'ounce',
};
